import { render } from "./EmailAttachments.vue?vue&type=template&id=a0f44f54&scoped=true"
import script from "./EmailAttachments.vue?vue&type=script&lang=js"
export * from "./EmailAttachments.vue?vue&type=script&lang=js"

import "./EmailAttachments.vue?vue&type=style&index=0&id=a0f44f54&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f44f54"]])

export default __exports__